<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-select
                    v-model="notificationTypeId"
                    :items="notificationTypeList"
                    name="notificationTypeId"
                    label="NotificationType"
                    v-validate="'required'"
                    data-vv-as="NotificationType"
                    :error-messages="errors.collect('notificationTypeId')"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    data-vv-as="Title"
                    :error-messages="errors.collect('title')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-textarea
                    v-model="message"
                    name="message"
                    label="Message"
                    v-validate="'required'"
                    data-vv-as="Message"
                    :error-messages="errors.collect('message')"
                    auto-grow
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service"
export default {
  computed: {
    title: {
      get() {
        return this.$store.state.notification.entity.title;
      },
      set(val) {
        this.$store.commit("notification/SET_NOTIFICATION_DATA", {
          key: "title",
          value: val
        });
      }
    },
    message: {
      get() {
        return this.$store.state.notification.entity.message;
      },
      set(val) {
        this.$store.commit("notification/SET_NOTIFICATION_DATA", {
          key: "message",
          value: val
        });
      }
    },
    notificationTypeId: {
      get() {
        return this.$store.state.notification.entity.notificationTypeId;
      },
      set(val) {
        this.$store.commit("notification/SET_NOTIFICATION_DATA", {
          key: "notificationTypeId",
          value: val
        });
      }
    },
    notificationTypeList: {
      get() {
        return this.$store.state.notification.notificationTypeList;
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Notification",
      loading: false,
      menu: false,
      menu1: false
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("notification/initNotification").then(() => {
      if (to.params.id) {
        store
          .dispatch("notification/setNotification", { id: to.params.id })
          .then(() => {
            next(p => {
              p.pageTitle = "Edit Notification";
            });
          });
      } else {
        next(p => {
          p.reset();
        });
      }
    });
  },
  methods: {
    submit() {
      if (this.loading) return;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch("notification/saveNotification").then(
            () => {
              commonservice.showSuccessMessage("Notification saved successfully");
              this.$router.push("/notification");
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        }
      });
    },
    reset() {
      this.$store.commit("notification/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    }
  }
};
</script>
